// @flow
import * as repositories from './repositories';
import * as drivers from './drivers';
import environment from './environment';
import uuid4 from 'uuid/v4';
import browserCookies from 'browser-cookies';
import {
  fetch,
  json,
  jsonRpc,
} from '@ux/drivers';
import * as r from 'ramda';
import TinyQueue from 'tinyqueue';

export default () => {
  const middlewareDriver = r.compose(
    drivers.middleware.createMiddlewareDriver(environment),
    json(),
    jsonRpc(),
  )(fetch);

  const analyticsQueue = new TinyQueue();

  return {
    analyticsQueue,

    fqdn: {
      isFqdnAvailable: repositories.fqdn.isFqdnAvailable(middlewareDriver),
    },
    suggestions: {
      getSuggestions: repositories.suggestions.getSuggestions(middlewareDriver),
    },
    browserSession: {
      getBrowserSession: repositories.browserSession.getBrowserSession(
        browserCookies,
      ),
      createBrowserSession: repositories.browserSession.createBrowserSession(
        browserCookies,
        uuid4,
      ),
    },
    ga: {
      sendAnalytics: repositories.ga.sendAnalytics(analyticsQueue),
      initialize: repositories.ga.initialize(analyticsQueue),
    },
    events: {
      emit: repositories.events.emit(document),
    },
    analyticsContext: {
      trackerId: r.path([ 'analytics', 'tracker' ], environment),
    },
  };
};
